import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Resets the current page to the first page when the applied params change in a
 * way that affects the matched count of the current list. This is useful for
 * cases where the applied params change in a way that would cause the current
 * page to be out of bounds (e.g. if the user is on page 3 and the applied
 * params change such that there are only 2 pages of results).
 */
export const resetPageOnQueryRequestChange = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.selectors.queryRequestThatAffectsMatchedCount.asObservable.pipe(
      rxjs.map(() =>
        plugin.appliedParams.actions.setSkip
          .from('resetPageOnQueryRequestChange (effect)')
          .create(0),
      ),
    ),
)
